const VRInfoDefaultStyle = {
    type: "Style",
    styleType: "text_box",
    name: "Default-Text-Box",
    alias: "Styles/Default-Text-Box",
    text: "Preview Text",
    guiText: "Text Box",
    backgroundColor: {r: 0, g: 0, b: 0, a: 0.3},
    textColor: {r: 255, g: 255, b: 255, a: 1.0},
    opacity: 0.8,
    fontFamily: "Helvetica",
    fontSize: 24,
    VRMode: "scene-follow",
    NonVRMode: "camera-fix",
    parent: null,
    Scene: {
        position: [
            0,
            -1,
            -4
        ],
        quaternion: [
            0,
            0,
            0,
            1
        ],
        scaleMultiplier: 1.0,
        sceneFollowPosition: 'Default',
        sceneFollowScale: 1.0,
    },
    Camera: {
        top: 72,
        left: 50,
        maxWidth: 60,
        maxHeight: 40
    },
};

module.exports = {
    VRInfoDefaultStyle
};